import React from 'react';
import * as translator from "../../../utils/translator";
import './LatePayment.css';
import FastCar from '../../../icons/Fast-Car-White.svg';


type DeliveryOption = 'express' | 'next_day' | 'dhl';

type Props = {
    language: string | undefined;
    isShown: boolean;
    setIsShown: (isShown: boolean) => void;
    onSelectDeliveryOption: (option: DeliveryOption) => void;
    reason: string;
    isNextDayAvailable: boolean;
};

const LatePayment: React.FC<Props> = ({ language, isShown, onSelectDeliveryOption, setIsShown, reason, isNextDayAvailable }) => {

    if (isShown) {
        window.eventsTracking.track({e: "Uber late payment popup shown"});
    }

    return (
    <>
    {isShown &&
        <div id="lp-overlay" className="lp-overlay">
            <div id="lp-container" className="lp-container">
                <div id="lp-header" className="lp-header">
                    <div id="lp-title-wrapper" className="lp-title-wrapper">
                        <img id="fast-car-icon" className='lp-icon' src={FastCar} alt="Fast Car" />
                        {translator.translate(language, "default", "late_payment_popup/title")}
                    </div>
                    <button 
                        id="lp-close-btn"
                        className="lp-close-btn"
                        onClick={() => {
                            window.eventsTracking.track({e: "Uber late payment stay express"});
                            setIsShown(false);
                        }}
                        aria-label="Close"
                    >
                        ×
                    </button>
                </div>

                <div id="lp-content" className="lp-content">
                    <div id="lp-message-box" className="lp-message-box">
                        <h3 id="lp-subtitle" className="lp-subtitle">{translator.translate(language, "default", "late_payment_popup/subtitle")}</h3>
                        <p id="lp-text-1" className="lp-text">
                            {translator.translate(language, "default", "late_payment_popup/message_1")}
                            <b id="lp-text-bold-1" className='lp-text-bold'>{translator.translate(language, "default", "late_payment_popup/message_1_highlight")}</b>
                        </p>
                        <p id="lp-text-2" className="lp-text">
                            {translator.translate(language, "default", "late_payment_popup/doctor_unavailable")}
                        </p>
                    </div>

                    <div id="lp-btn-group" className="lp-btn-group">
                            <button 
                                id="lp-option-btn-express"
                                className="lp-option-btn"
                                onClick={() => onSelectDeliveryOption('express')}
                            >
                            {
                                reason === "doctors_unavailable" 
                                    ?
                                    <div id="lp-btn-content-express-retry" className="lp-btn-content">
                                        {translator.translate(language, "default", "late_payment_popup/try_again")}
                                    </div>
                                    :
                                    <div id="lp-btn-content-express-stay" className="lp-btn-content">
                                        {translator.translate(language, "default", "late_payment_popup/stay_with_express")}
                                    </div>
                            }
                            </button>

                            {isNextDayAvailable && (
                                <button
                                    id="lp-option-btn-next-day"
                                    className="lp-option-btn"
                                    onClick={() => onSelectDeliveryOption('next_day')}
                                >
                                    <div id="lp-btn-content-next-day" className="lp-btn-content">
                                        {translator.translate(language, "default", "late_payment_popup/switch_to_next_day")}
                                    </div>
                                </button>
                            )}

                            <button
                                id="lp-option-btn-dhl"
                                className="lp-option-btn"
                                onClick={() => onSelectDeliveryOption('dhl')}
                            >
                                <div id="lp-btn-content-dhl" className="lp-btn-content">
                                    {translator.translate(language, "default", "late_payment_popup/switch_to_dhl")}
                                </div>
                            </button>
                    </div>
                </div>
            </div>
        </div>
    }
    </>
    );
};

export default LatePayment;